import React from "react";

import { cx } from "../../utils/functions";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "black" | "neutral";
  small?: boolean;
}

export const Button = (props: ButtonProps) => {
  const { children, variant, small, className, ...rest } = props;

  return (
    <button
      className={cx(
        "btn",
        small && "btn-small",
        variant === "primary" && "btn-primary",
        variant === "secondary" && "btn-secondary",
        variant === "neutral" && "btn-neutral",
        variant === "black" && "bg-black text-white",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};
